<script setup lang="ts">
defineProps<{
  state: 'free' | 'everyoneHas' | 'someHave' | 'noOneHas',
  text: string
}>()
</script>

<template>
  <div class="w-full py-0.5 px-2 rounded-2xl flex justify-between items-center border-2 select-text" :class="{
    'bg-emerald-300 border-emerald-300': state === 'free' || state === 'everyoneHas',
    'bg-yellow-200 border-yellow-200': state === 'someHave',
    'bg-zinc-100 border-zinc-100 text-black/50': state === 'noOneHas'
  }">
    <span class="flex w-full items-center pr-1 text-black text-sm">
      {{ text }}
    </span>
    <span class="flex-shrink-0 h-4 w-4">
      <img v-if="state === 'free'" src="../assets/free.svg" class="h-4 w-4 opacity-75" alt="This activity is free to play for all players" />
      <img v-else-if="state === 'everyoneHas'" src="../assets/check.svg" class="h-4 w-4 opacity-75" alt="Everyone has access to this activity" />
      <img v-else-if="state === 'someHave'" src="../assets/warning.svg" class="h-4 w-4 opacity-75" alt="Not enough people have access to this activity" />
    </span>
  </div>
</template>
